module.exports = __webpack_public_path__ + "img/12.e142a11e.jpg";